import { render, staticRenderFns } from "./ScaList.vue?vue&type=template&id=18cbd578&scoped=true&"
import script from "./ScaList.vue?vue&type=script&lang=ts&"
export * from "./ScaList.vue?vue&type=script&lang=ts&"
import style0 from "./ScaList.vue?vue&type=style&index=0&id=18cbd578&scoped=true&lang=scss&"
import style1 from "./ScaList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbd578",
  null
  
)

export default component.exports